import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { DropdownConfigModel } from './shared/models/dropdown.model';

@Component({
    selector: 'app-radius-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent implements OnInit, OnChanges {
  //   public test;
  @Input() items = [];
  @Input() selectedItem;
  @Input() dropdownConfig = new DropdownConfigModel();
  @Input() forceClose: boolean;
  @Input() showMessage = '';
  @Input() isDisabled: boolean;
  // @Input() showNoData;
  @Input() noDataFoundMessage;
  @Input() dropdownScreenRef;

  @Output() dropdownOpen = new EventEmitter();
  @Output() search = new EventEmitter();
  @Output() hasScroll = new EventEmitter();
  @Output() realtimesearch = new EventEmitter();
  @Output() itemselected = new EventEmitter();
  @Output() addTag = new EventEmitter();

  public isOpen = false;
  public message = '';
  public exception = false;
  inputModelChanged: Subject<string> = new Subject<string>();

  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  clickedOutside(event): void {
    if (this.menu && this.menu.nativeElement.contains(event.target)) {
      return;
    } else if (this.toggleButton && this.toggleButton.nativeElement.contains(event.target)) {
      return;
    }
    this.isOpen = false;
  }

  ngOnInit(): void {
    this.inputModelChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(model => {
      this.dropdownConfig.searchtext = model;
      this.realtimesearch.emit(this.dropdownConfig.searchtext);
    });
  }

  ngOnChanges(): void {
    if (this.dropdownConfig === undefined) {
      this.dropdownConfig = new DropdownConfigModel();
    }

    if (this.dropdownConfig.getMultiSelect()) {
      if (this.selectedItem !== undefined) {
        if (this.selectedItem.constructor !== Array) {
          this.toggleMessage('Exception: Selected Item must be an array when multiselect is true', true);
        }
      }
    }

    if (!this.dropdownConfig.getItemSimpleArray()) {
      if (!this.dropdownConfig.getBindLabel() && !this.dropdownConfig.getBindValue()) {
        this.toggleMessage('Exception: Bind Value and Bind Label must be provided when SimpleArray is false', true);
      }
    }

    if (this.showMessage.length) {
      this.toggleMessage(this.showMessage);
    }
  }

  get getSelectedItem(): any {
    if (this.selectedItem !== undefined) {
      if (this.dropdownConfig.getMultiSelect()) {
        if (this.selectedItem.length > 0) {
          if (this.dropdownConfig.getItemSimpleArray()) {
            return this.selectedItem.toString();
          } else {
            const arr = [];
            for (const j of this.selectedItem) {
              for (const i of this.items) {
                if (i[this.dropdownConfig.getBindValue()] === j) {
                  arr.push(i[this.dropdownConfig.getBindLabel()]);
                }
              }
            }
            return arr.toString();
          }
        }
        return this.dropdownConfig.getPlaceholder();
      } else {
        if (this.dropdownConfig.getItemSimpleArray()) {
          return this.selectedItem.toString();
        } else {
          const item = this.selectedItem;
          for (const i of this.items) {
            if (i[this.dropdownConfig.getBindValue()] === item) {
              return i[this.dropdownConfig.getBindLabel()];
            }
          }
        }
      }
    }
    return this.dropdownConfig.getPlaceholder();
  }

  get isPlaceHolder(): boolean {
    if (this.selectedItem !== undefined) {
      if (this.dropdownConfig.getMultiSelect()) {
        return this.selectedItem.length === 0;
      }
      return false;
    }
    return true;
  }

  get areAllSelected(): boolean {
    if (this.dropdownConfig.getMultiSelect()) {
      if (this.selectedItem !== undefined) {
        return this.items.length === this.selectedItem.length;
      }
    } else {
      return false;
    }
  }

  public toggleMessage(message, exception = false): void {
    this.message = message;
    this.exception = exception;

    if (!exception) {
      setTimeout(() => {
        this.message = '';
      }, 3000);
    }
  }

  public resolveBindingLabels(item, type = 'label'): any {
    if (!this.dropdownConfig.getItemSimpleArray()) {
      if (type === 'label') {
        return item[this.dropdownConfig.getBindLabel()];
      }
      return item[this.dropdownConfig.getBindValue()];
    }
    return item;
  }

  public onSelect(item): void {
    if (this.dropdownConfig.getMultiSelect()) {
      if (this.selectedItem === undefined) {
        this.selectedItem = [];
      }
      if (this.isItemPresentInSelection(item)) {
        const index = this.selectedItem.indexOf(this.resolveBindingLabels(item, 'value'));
        if (index > -1) {
          this.selectedItem.splice(index, 1);
        }
      } else {
        this.selectedItem.push(this.resolveBindingLabels(item, 'value'));
      }
    } else {
      this.selectedItem = this.resolveBindingLabels(item, 'value');
    }

    this.itemselected.emit(this.selectedItem);
    if (!this.dropdownConfig.getMultiSelect()) {
      this.toggleDropdownOpenState();
    }
  }

  public toggleDropdownOpenState(): void {
    if(this.dropdownConfig.getDisabledValue()){
      this.isOpen = false;
      this.dropdownOpen.emit(this.isOpen);
      return
    }
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.dropdownOpen.emit(this.isOpen);
    this.dropdownConfig.searchtext = null;
  }

  public onClearingItems(): void {
    event.stopPropagation();
    if (this.dropdownConfig.getMultiSelect()) {
      this.selectedItem = [];
    } else {
      this.selectedItem = undefined;
    }
    this.itemselected.emit(this.selectedItem);
  }

  public isItemPresentInSelection(item): boolean {
    if (this.dropdownConfig.getMultiSelect()) {
      if (!this.dropdownConfig.getItemSimpleArray()) {
        if (this.selectedItem === undefined) {
          return false;
        }

        for (const i of this.selectedItem) {
          if (i === item[this.dropdownConfig.getBindValue()]) {
            return true;
          }
        }
        return false;
      } else {
        try {
          return this.selectedItem.indexOf(item) >= 0;
        } catch (e) {
          return false;
        }
      }
    } else {
      if (!this.dropdownConfig.getItemSimpleArray()) {
        return this.selectedItem === item[this.dropdownConfig.getBindValue()];
      } else {
        return this.selectedItem === item;
      }
    }
  }

  public isItemPresentInDropdownItems(item): boolean {
    if (this.dropdownConfig.getItemSimpleArray()) {
      // return this.items.includes(item);
      // doing case insensitive
      // const itemsCaseInsensitive = this.items.map(i => i.toLowerCase());
      // return itemsCaseInsensitive.includes(item.toLowerCase());
      return this.items.some(i => i.toLowerCase() === item.toLowerCase()); // more efficient
    } else {
      for (const i of this.items) {
        if (i[this.dropdownConfig.getBindLabel()] === item[this.dropdownConfig.getBindLabel()]) {
          return true;
        }
      }
      return false;
    }
  }

  public onSearch(): void {
    this.search.emit(this.dropdownConfig.searchtext);
  }

  public onRealTimeSearch(): void {
    this.realtimesearch.emit(this.dropdownConfig.searchtext);
  }

  public onScroll(): void {
    this.hasScroll.emit();
  }

  public onAddTag(): void {
    // Is Add Tag Enabled
    if (this.dropdownConfig.getAddTag()) {
      // Is it a Simple Array
      if (this.dropdownConfig.getItemSimpleArray()) {
        // Is the Item present in Items Array
        if (!this.isItemPresentInDropdownItems(this.dropdownConfig.searchtext)) {
          // If maxTagLength is specified
          if (
            this.dropdownConfig.getMaxTagLength() !== undefined &&
            this.dropdownConfig.searchtext &&
            this.dropdownConfig.searchtext.length > this.dropdownConfig.getMaxTagLength()
          ) {
            this.toggleMessage(`Error: Maximum ${this.dropdownConfig.getMaxTagLength()} characters allowed.`);
          } else {
            this.items.unshift(this.dropdownConfig.searchtext);

            // Push inside Selected Item
            if (this.dropdownConfig.getPushOnAddTag()) {
              if (this.dropdownConfig.getMultiSelect()) {
                if (this.selectedItem === undefined) {
                  this.selectedItem = [];
                }

                if (!this.isItemPresentInSelection(this.dropdownConfig.searchtext)) {
                  this.selectedItem.unshift(this.dropdownConfig.searchtext);
                }
              } else {
                this.selectedItem = this.dropdownConfig.searchtext;
              }
              this.addTag.emit(this.selectedItem);
            }
          }
        } else {
          this.toggleMessage('Error: The selected item is already present in the list.');
        }
      } else {
        // Create Dict from Labels (Not a simple Array)
        const temp = {};
        temp[this.dropdownConfig.getBindLabel()] = this.dropdownConfig.searchtext;
        temp[this.dropdownConfig.getBindValue()] = this.dropdownConfig.searchtext;

        // Is the Item present in Items Array
        if (!this.isItemPresentInDropdownItems(this.dropdownConfig.searchtext)) {
          this.items.unshift(temp);

          // Push inside Selected Item
          if (this.dropdownConfig.getPushOnAddTag()) {
            if (this.dropdownConfig.getMultiSelect()) {
              if (this.selectedItem === undefined) {
                this.selectedItem = [];
              }

              if (!this.isItemPresentInSelection(temp)) {
                this.selectedItem.unshift(temp[this.dropdownConfig.getBindValue()]);
              }
            } else {
              this.selectedItem = temp;
            }
          }
        } else {
          this.toggleMessage('Error: The selected item is already present in the list.');
        }
      }
    }
  }

  onSelectAll(): void {
    const allSelectCheck = this.areAllSelected;
    if (this.areAllSelected) {
      this.selectedItem = [];
    } else {
      if (this.dropdownConfig.getItemSimpleArray()) {
        this.selectedItem = JSON.parse(JSON.stringify(this.items));
      } else {
        const arr = [];
        for (const i of this.items) {
          arr.push(i[this.dropdownConfig.getBindValue()]);
        }
        this.selectedItem = arr;
      }
    }

    const selection =
      this.dropdownScreenRef === 'trialUniverse' ? (!allSelectCheck ? 'all' : this.selectedItem) : this.selectedItem;
    this.itemselected.emit(selection);
  }
}
